import "../../node_modules/.pnpm/vue@3.5.13_typescript@4.9.5/node_modules/vue/dist/vue.runtime.esm-bundler.es.js";
import { defineComponent, resolveComponent, openBlock, createElementBlock, createVNode, withCtx, createTextVNode } from "../../node_modules/.pnpm/@vue_runtime-core@3.5.13/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.es.js";
import { toDisplayString } from "../../node_modules/.pnpm/@vue_shared@3.5.13/node_modules/@vue/shared/dist/shared.esm-bundler.es.js";
import { withModifiers } from "../../node_modules/.pnpm/@vue_runtime-dom@3.5.13/node_modules/@vue/runtime-dom/dist/runtime-dom.esm-bundler.es.js";
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "WsLabelLink",
  props: {
    href: {
      type: String,
      required: true
    },
    target: {
      type: String,
      default: void 0
    },
    label: {
      type: String,
      default: "uikit:general.link"
    }
  },
  setup(__props) {
    const props = __props;
    const handleClick = () => window.open(props.href, props.target);
    return (_ctx, _cache) => {
      const _component_portal_slot = resolveComponent("portal-slot");
      return openBlock(), createElementBlock("a", {
        class: "ws-link",
        href: "javascript:void(0)",
        onClick: withModifiers(handleClick, ["prevent", "stop"])
      }, [
        createVNode(_component_portal_slot, {
          slot: _ctx.$slots.default,
          "component-id": _ctx.$attrs["component-id"]
        }, {
          default: withCtx(() => [
            createTextVNode(toDisplayString(_ctx.$t(props.label)), 1)
          ]),
          _: 1
        }, 8, ["slot", "component-id"])
      ]);
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=WsLabelLink.vue.es.js.map
